import { Button, NavigateButton, Space } from '@/components';
import { getProjectDetailPageUrl } from '@/features/project/_utils/project';
import { isPS } from '@/utils';
import { ExportOutlined } from '@ant-design/icons';
import type { FC } from 'react';
import { useTranslation } from 'react-i18next';

type Props = {
  projectId: string;
};

export const NavigateDetailsWithOpenButton: FC<Props> = ({ projectId }) => {
  const { t } = useTranslation();
  const path = getProjectDetailPageUrl({
    isPS: isPS(),
    projectId,
    onlyPath: true,
  });
  const fullPath = getProjectDetailPageUrl({
    isPS: isPS(),
    projectId,
  });

  return (
    <Space direction="vertical" align="center">
      <NavigateButton
        type="default"
        path={path}
        fullPath={true}
        text={t('details')}
      />
      <Button
        type="link"
        icon={<ExportOutlined />}
        onClick={() => {
          window.open(fullPath, '_blank', 'noopener,noreferrer');
        }}
      >
        {t('details')}
      </Button>
    </Space>
  );
};
